module.exports = __webpack_public_path__ + "img/image-map-4-fc207b73.png";